"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelUpTableToJSON = exports.LevelUpTableFromJSONTyped = exports.LevelUpTableFromJSON = void 0;
function LevelUpTableFromJSON(json) {
    return LevelUpTableFromJSONTyped(json, false);
}
exports.LevelUpTableFromJSON = LevelUpTableFromJSON;
function LevelUpTableFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LevelUpTableFromJSONTyped = LevelUpTableFromJSONTyped;
function LevelUpTableToJSON(value) {
    return value;
}
exports.LevelUpTableToJSON = LevelUpTableToJSON;
